import { FC, useEffect, useState } from "react";
import { InputProps } from "./InputProps";
import { SurveyPostObject } from "../../service/apiHelper";
const Radio: FC<{
  label: string;
  isSelected: boolean;
  toggleSelection: Function;
  isRequired: boolean;
  name: string;
}> = ({ label, isSelected, toggleSelection, isRequired, name }) => {
  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    toggleSelection(event.currentTarget.value);
  };
  return (
    <div className="relative flex items-start pt-2">
      <div className="flex items-center h-6">
        <input
          value={label}
          aria-describedby={label}
          name={name}
          checked={isSelected}
          onChange={handleChange}
          type="radio"
          className="w-4 h-4 border-gray-300 text-primary-600 focus:ring-primary-600"
        />
      </div>
      <div className="leading-6">
        <label htmlFor={label} className="ml-3 text-sm text-gray-900">
          {label}
        </label>
      </div>
    </div>
  );
};

export const RadioSet: FC<{
  inputProps: InputProps;
  handleChange: Function;
}> = ({ inputProps, handleChange }) => {
  const [selectedId, setSelectedId] = useState("");

  const onChangeHandler = (selectedLabel: string) => {
    setSelectedId(selectedLabel);
    const newProps: SurveyPostObject = {
      SurveyId: inputProps.id,
      SurveyLabel: inputProps.label,
      ResponseText: selectedLabel,
      ResponseValue: selectedLabel,
    };

    handleChange(newProps);
  };

  return (
    <fieldset>
      <p className="text-sm text-gray-900">
        {inputProps.label}{" "}
        {inputProps.required && <span className="text-error-600">*</span>}
      </p>
      {inputProps.options?.map((item, index) => (
        <Radio
          key={index}
          name={inputProps.id}
          label={item.label}
          isRequired={inputProps.required}
          isSelected={selectedId === item.label ? true : false}
          toggleSelection={onChangeHandler}
        />
      ))}
    </fieldset>
  );
};
